import { useMemo } from 'react';

import { Ajax } from '@newrelic/browser-agent/features/ajax';
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events';
import { JSErrors } from '@newrelic/browser-agent/features/jserrors';
import { SessionTrace } from '@newrelic/browser-agent/features/session_trace';
import { Agent } from '@newrelic/browser-agent/loaders/agent';

export type AgentInstance = InstanceType<typeof Agent>;
let agentInstance: AgentInstance | null = null;

export function initNewRelicAgent(): void {
	try {
		agentInstance = new Agent({
			...APP_SETTINGS.newRelicAgentConfig,
			features: [GenericEvents, JSErrors, Ajax, SessionTrace],
		});
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Failed to initialize New Relic agent:', error);
	}
}

export function getNewRelicAgent(): AgentInstance | null {
	return agentInstance;
}

export function useAgent(): AgentInstance | null {
	const agent = useMemo(() => getNewRelicAgent(), []);
	return agent;
}
